import { render } from "./Paragraphs.vue?vue&type=template&id=ba20f602"
import script from "./Paragraphs.vue?vue&type=script&lang=js"
export * from "./Paragraphs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akrug/Sites/RetirePath/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__